import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FloatingButton } from "../../../../../ds";
import { useAuth } from "../../../../../providers";
import { SubscriptionPageControllerImpl, SubscriptionStrings } from "../../../business";
import { SubscriptionDataResponse } from "../../interfaces";
import { SubscriptionPageFactoryImpl } from "../factories";

export const SubscriptionPage: React.FC = () => {
    const strings = SubscriptionStrings['PTBR'].page;
    const { setCallbackLogin, handleLogout } = useAuth();
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<Boolean>(true);
    const [plansData, setPlansData] = useState<SubscriptionDataResponse>();

    const factory = new SubscriptionPageFactoryImpl();
    const controller = new SubscriptionPageControllerImpl();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fetchData = async () => {
        try {
            const response = await controller.onLoad();
            setLoading(false);
            setPlansData(response);
        } catch (error) {
            console.error("Erro na requisição:", error);
            if (error === "401") {
                setCallbackLogin(
                    {
                        goBack: true,
                        origin: '/subscription',
                    }
                );
                handleLogout();
                navigate('/auth');
            } else {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className={"font-poppins"} style={{ marginTop: -65 }}>
                <h1 style={{ fontSize: "5vw", fontWeight: "bold", color: 'white' }} className="text-shadow">{strings.title}</h1>
                {isLoading ? <Spinner animation="border" variant="primary" /> : factory.create(plansData)}
            </div>
            <div className={"mb-5 pb-5"}>
                <p
                    className={"text-center"}
                    dangerouslySetInnerHTML={{ __html: strings.description }}
                />
            </div>
            <FloatingButton />
        </>
    );
}
